import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { action, computed, observable } from 'mobx';
import { task } from 'mobx-task';
import { ConfirmDialogState } from '../components/ConfirmDialog';
import InfiniteScrollProvider from '../data/InfiniteScrollProvider';
import { extractMessageFromError } from '../utils/errorUtil';
import InviteTeamMemberState from './InviteTeamMemberState';
import AddTeamMemberState from './AddTeamMemberState';
import TeamBillingViewState from './TeamBillingViewState';
import TeamInfoViewState from './TeamInfoViewState';

/**
 * Team details view state.
 */
export var TeamDetailsViewState = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = task.resolved, _dec6 = task.resolved, _class = /*#__PURE__*/function () {
  /**
   * Creates the details view state.
   */
  function TeamDetailsViewState(_ref) {
    var teamStore = _ref.teamStore,
      teamMemberStore = _ref.teamMemberStore,
      invitationStore = _ref.invitationStore,
      teamRoleStore = _ref.teamRoleStore,
      flashMessageStore = _ref.flashMessageStore,
      billingStore = _ref.billingStore,
      sessionStore = _ref.sessionStore,
      team = _ref.team,
      jobStore = _ref.jobStore,
      memberStore = _ref.memberStore,
      allowEdit = _ref.allowEdit,
      onViewList = _ref.onViewList,
      target = _ref.target;
    _classCallCheck(this, TeamDetailsViewState);
    /**
     * The team that this state represents.
     * Never changes.
     */
    this.team = null;
    /**
     * Current tab.
     */
    _initializerDefineProperty(this, "currentTab", _descriptor, this);
    /**
     * The ID of the selected team role to filter on. `null` = all
     */
    _initializerDefineProperty(this, "selectedTeamRoleFilterId", _descriptor2, this);
    /**
     * Member scroller.
     */
    this.memberScroller = new InfiniteScrollProvider({
      fetchItems: this._fetchMembers.bind(this),
      memoizeInitial: true
    });
    this.teamStore = teamStore;
    this.teamMemberStore = teamMemberStore;
    this.teamRoleStore = teamRoleStore;
    this.billingStore = billingStore;
    this.sessionStore = sessionStore;
    this.invitationStore = invitationStore;
    this.team = team;
    this.allowEdit = allowEdit;
    this.onViewList = onViewList;
    this.confirmDeactivateState = new ConfirmDialogState();
    this.addTeamMemberState = new AddTeamMemberState({
      team: team,
      teamMemberStore: teamMemberStore,
      teamRoleStore: teamRoleStore,
      invitationStore: invitationStore,
      flashMessageStore: flashMessageStore
    });
    this.inviteTeamMemberState = new InviteTeamMemberState({
      team: team,
      teamMemberStore: teamMemberStore,
      teamRoleStore: teamRoleStore,
      invitationStore: invitationStore,
      flashMessageStore: flashMessageStore,
      target: target
    });
    this.infoViewState = new TeamInfoViewState({
      teamStore: teamStore,
      flashMessageStore: flashMessageStore,
      team: team,
      onViewList: onViewList
    });
    this.billingViewState = new TeamBillingViewState({
      team: team,
      billingStore: billingStore,
      flashMessageStore: flashMessageStore,
      jobStore: jobStore,
      memberStore: memberStore
    });
    // This state is instantiated on demand and is
    // discarded when no longer needed. Therefore. we can call `activate` here.
    this.activate();
  }

  /**
   * Available team roles.
   */
  return _createClass(TeamDetailsViewState, [{
    key: "teamRoles",
    get: function get() {
      return this.teamRoleStore.forWorkspace(this.team.workspaceId);
    }

    /**
     * Team members.
     */
  }, {
    key: "teamMembers",
    get: function get() {
      var _this = this;
      var teamMembers = this.teamMemberStore.forTeam(this.team.id).filter(function (teamMember) {
        if (!_this.selectedTeamRoleFilterId) {
          return true;
        }
        return teamMember.teamRoleId === _this.selectedTeamRoleFilterId;
      });
      return teamMembers;
    }
  }, {
    key: "pendingMembers",
    get: function get() {
      var _this2 = this;
      return this.invitationStore.pendingMembers.filter(function (pendingMember) {
        return pendingMember.team_id && pendingMember.team_id === _this2.team.id;
      });
    }

    /**
     * Are we busy doing any remote calls
     */
  }, {
    key: "busy",
    get: function get() {
      return this.changeTeamMemberRole.pending;
    }

    /**
     * Fetches what needs fetching.
     */
  }, {
    key: "activate",
    value: (function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var teamMember;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              teamMember = this.teamMemberStore.forTeamAndUser(this.team.id, this.sessionStore.member.userId);
              if (!(teamMember && teamMember.hasPermission('MANAGE_TEAM_MEMBER'))) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return this.invitationStore.findPending({
                workspace_id: this.team.workspaceId,
                team_id: this.team.id
              });
            case 4:
              _context.next = 6;
              return Promise.all([this.teamRoleStore.fetchTeamRolesForWorkspace(this.team.workspaceId), this.memberScroller.fetch(), this.infoViewState.activate(), this.billingViewState.activate()]);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
    /**
     * Sets the tab.
     *
     * @param {*} id
     */
    )
  }, {
    key: "setTab",
    value: function setTab(id) {
      this.currentTab = id;
    }

    /**
     * Sets the role filter.
     *
     * @param {*} id
     */
  }, {
    key: "setRoleFilter",
    value: function setRoleFilter(id) {
      this.selectedTeamRoleFilterId = id;
    }

    /**
     * Shows the invite modal, passing in the current filter for
     * roles to be used as a default.
     */
  }, {
    key: "showInviteModal",
    value: function showInviteModal() {
      this.inviteTeamMemberState.show(this.selectedTeamRoleFilterId);
    }
  }, {
    key: "showAddModal",
    value: function showAddModal() {
      this.addTeamMemberState.show(this.selectedTeamRoleFilterId);
    }

    /**
     * Changes the team member role.
     *
     * @param {*} teamMember
     * @param {*} newRoleId
     */
  }, {
    key: "changeTeamMemberRole",
    value: (function () {
      var _changeTeamMemberRole = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(teamMember, newRoleId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(teamMember.teamRoleId === newRoleId)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return this.teamMemberStore.updateTeamMemberByPublicId({
                team_id: teamMember.teamId,
                user_id: teamMember.userPublicId
              }, {
                team_role_id: newRoleId
              });
            case 5:
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](2);
              this.teamMemberStore.rootStore.flashMessageStore.create({
                type: 'error',
                message: extractMessageFromError(_context2.t0)
              });
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 7]]);
      }));
      function changeTeamMemberRole(_x, _x2) {
        return _changeTeamMemberRole.apply(this, arguments);
      }
      return changeTeamMemberRole;
    }()
    /**
     * Deactivates the team member
     *
     * @param {*} teamMember
     */
    )
  }, {
    key: "removeTeamMember",
    value: (function () {
      var _removeTeamMember = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(teamMember) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.confirmDeactivateState.show();
            case 2:
              if (_context3.sent) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              _context3.prev = 4;
              _context3.next = 7;
              return this.teamMemberStore.deleteTeamMemberByPublicId({
                team_id: teamMember.teamId,
                user_id: teamMember.userPublicId
              });
            case 7:
              if (teamMember.userId === this.teamMemberStore.rootStore.sessionStore.user.id) {
                this.onViewList();
              }
              _context3.next = 13;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](4);
              this.teamMemberStore.rootStore.flashMessageStore.create({
                type: 'error',
                message: extractMessageFromError(_context3.t0)
              });
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 10]]);
      }));
      function removeTeamMember(_x3) {
        return _removeTeamMember.apply(this, arguments);
      }
      return removeTeamMember;
    }()
    /**
     * Fetches members for the scroller.
     *
     * @param {*} params
     */
    )
  }, {
    key: "_fetchMembers",
    value: function _fetchMembers(params) {
      return this.teamMemberStore.find(_objectSpread(_objectSpread({}, params), {}, {
        team_id: this.team.id
      }));
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'MEMBERS';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedTeamRoleFilterId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "teamRoles", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "teamRoles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teamMembers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "teamMembers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pendingMembers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pendingMembers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "busy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "busy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activate", [task], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTab", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "setTab"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRoleFilter", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "setRoleFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showInviteModal", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "showInviteModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAddModal", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "showAddModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeTeamMemberRole", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "changeTeamMemberRole"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeTeamMember", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "removeTeamMember"), _class.prototype), _class);
//# sourceMappingURL=TeamDetailsViewState.js.map
